var _a, _b;
import { __assign, __spreadArray } from "tslib";
import { handleActions, combineActions } from 'redux-actions';
import without from 'lodash/without';
import { commitCollections, commitCollectionsSuccess, commitCollectionsFail, initializeDeviationCollectionsCustom, createCollection, createCollectionSuccess, createCollectionFail, undoChanges, toggleCollection, changeFave, changeFaveSuccess, changeFaveFail, setFaveState, resetJustFaved, } from './actionCreators';
import { reduxKey } from './constants';
import { unloadDuperbrowseItem } from '../../Duperbrowse/redux/actionCreators';
// helper method to set per-deviation states easier
function setDeviationState(state, _a, getValues) {
    var _b;
    var _c, _d;
    var payload = _a.payload;
    var deviationId = (_c = payload === null || payload === void 0 ? void 0 : payload.deviationId) !== null && _c !== void 0 ? _c : (_d = payload === null || payload === void 0 ? void 0 : payload.deviation) === null || _d === void 0 ? void 0 : _d.deviationId;
    // if the action does not have deviation or deviationId, bail
    if (!deviationId) {
        return state;
    }
    // we use a callback to figure out the next state
    var newValues = getValues(state.deviations[deviationId], payload);
    // if callback returns nothing, means there's nothing to change
    if (!newValues) {
        return state;
    }
    return __assign(__assign({}, state), { deviations: __assign(__assign({}, state.deviations), (_b = {}, _b[deviationId] = newValues, _b)) });
}
var handler = handleActions((_a = {},
    _a[combineActions(undoChanges, unloadDuperbrowseItem).toString()] = function (state, action) {
        return setDeviationState(state, action, function (oldValue) {
            return oldValue && __assign(__assign({}, oldValue), { selectedCollections: oldValue.savedCollections });
        });
    },
    _a[initializeDeviationCollectionsCustom.toString()] = function (state, action) {
        if (!action.payload) {
            return state;
        }
        var ignorePreselectedCollections = action.payload.ignorePreselectedCollections;
        return __assign(__assign({}, setDeviationState(state, action, function (oldValue, payload) { return ({
            isInitializedForCollecting: true,
            isFavourite: payload.collectionids.length > 0,
            isLoading: false,
            faveCount: payload.faveCount,
            selectedCollections: ignorePreselectedCollections
                ? []
                : payload.collectionids,
            savedCollections: payload.collectionids,
            justFaved: false,
        }); })), { isNewCollectionSaving: false });
    },
    _a[toggleCollection.toString()] = function (state, action) {
        return setDeviationState(state, action, function (oldValue, payload) {
            if (!oldValue) {
                return;
            }
            var selected = oldValue.selectedCollections;
            // if the folder was selected, we remove it; otherwise add it
            var newSelected = selected.includes(payload.folderId)
                ? without(selected, payload.folderId)
                : __spreadArray(__spreadArray([], selected, true), [payload.folderId], false);
            return __assign(__assign({}, oldValue), { selectedCollections: newSelected });
        });
    },
    _a[commitCollections.toString()] = function (state, action) {
        return setDeviationState(state, action, function (oldValue) {
            return oldValue && __assign(__assign({}, oldValue), { isLoading: true });
        });
    },
    _a[commitCollectionsSuccess.toString()] = function (state, action) {
        return setDeviationState(state, action, function (oldValue, _a) {
            var folderIds = _a.folderIds;
            return oldValue && __assign(__assign({}, oldValue), { selectedCollections: folderIds, savedCollections: folderIds, isLoading: false });
        });
    },
    _a[commitCollectionsFail.toString()] = function (state, action) {
        return setDeviationState(state, action, function (oldValue) {
            return oldValue && __assign(__assign({}, oldValue), { isLoading: false });
        });
    },
    _a[createCollection.toString()] = function (state) { return (__assign(__assign({}, state), { isNewCollectionSaving: true })); },
    _a[createCollectionSuccess.toString()] = function (state) { return (__assign(__assign({}, state), { isNewCollectionSaving: false })); },
    _a[createCollectionFail.toString()] = function (state) { return (__assign(__assign({}, state), { isNewCollectionSaving: false })); },
    _a[combineActions(changeFave, setFaveState).toString()] = function (state, action) {
        return setDeviationState(state, action, function (oldValue, payload) {
            var deviation = payload.deviation, isFavourited = payload.deviation.isFavourited, to = payload.to;
            // sometimes we only want to change the favedness in the store
            // eg. when the collections are being updated
            // this means we can skip changing a bunch of values
            var isPureSet = action.type === setFaveState.toString();
            if (isPureSet && !oldValue) {
                return;
            }
            var isFavouritedNow = oldValue && oldValue.isFavourite !== undefined
                ? oldValue.isFavourite
                : isFavourited || false;
            var willBeFavourited = to === undefined ? !isFavouritedNow : to;
            if (isFavouritedNow === willBeFavourited) {
                // nothing to do
                return oldValue;
            }
            var favesNow = oldValue && oldValue.faveCount !== undefined
                ? oldValue.faveCount
                : (deviation.stats && deviation.stats.favourites) || 0;
            return __assign(__assign({}, oldValue), { isFavourite: willBeFavourited, justFaved: !isPureSet && !isFavouritedNow && willBeFavourited, faveCount: Math.max(favesNow + (willBeFavourited ? 1 : -1), 0), isLoading: !isPureSet, isInitializedForCollecting: isPureSet
                    ? oldValue.isInitializedForCollecting
                    : false, savedCollections: isPureSet ? oldValue.savedCollections : [], selectedCollections: isPureSet ? oldValue.selectedCollections : [] });
        });
    },
    _a[changeFaveSuccess.toString()] = function (state, action) {
        return setDeviationState(state, action, function (oldValue) {
            return oldValue && __assign(__assign({}, oldValue), { isLoading: false });
        });
    },
    _a[changeFaveFail.toString()] = function (state, action) {
        return setDeviationState(state, action, function (oldValue) {
            return oldValue && __assign(__assign({}, oldValue), { isFavourite: !oldValue.isFavourite, justFaved: false, faveCount: oldValue.faveCount + (oldValue.isFavourite ? -1 : 1) });
        });
    },
    _a[resetJustFaved.toString()] = function (state, action) {
        return setDeviationState(state, action, function (oldValue) {
            return oldValue && __assign(__assign({}, oldValue), { justFaved: false });
        });
    },
    _a), {
    deviations: {},
    isNewCollectionSaving: false,
});
export default (_b = {},
    _b[reduxKey] = handler,
    _b);
//# sourceMappingURL=reducer.js.map